import { MatterViewerRole } from '@/matter/store/schemas'
import type { MatterRead, MatterReadForTable } from '@/matter/store/schemas'

/**
 * Returns true when the current user has a *pending* collaborator invite to this matter:
 * invited as a collaborator (invited_at set) but has not yet accepted (accepted_at null).
 *
 * Centralizing the check here keeps the matters-table call sites (pill, row activation,
 * overflow-menu disabling) from each re-implementing it.
 */
export function isPendingMatterInvite(matter: MatterRead | MatterReadForTable | null | undefined): boolean {
  if (!matter) return false
  return (
    (matter.viewer_role === MatterViewerRole.Collaborator || matter.viewer_role === MatterViewerRole.Editor) &&
    matter.invited_at !== null &&
    matter.accepted_at === null
  )
}
